import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-provider-info-cell',
    templateUrl: './provider-info-cell.component.html',
    styleUrls: ['./provider-info-cell.component.css']
})
export class ProviderInfoCellComponent {
    public cellValue!: any;

    agInit(params: ICellRendererParams): void {
        this.cellValue = params;
    }

    refresh(params: ICellRendererParams): boolean {
        this.cellValue = params;
        return true;
    }

    get data(): any {
        return this.cellValue?.data || {};
    }
}
